var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

/**
 * Rabin fingerprinting
 *
 * @class Rabin
 */
var Rabin = /*#__PURE__*/function () {
  "use strict";

  /**
   * Creates an instance of Rabin.
   * @param { import("./../dist/rabin-wasm") } asModule
   * @param {number} [bits=12]
   * @param {number} [min=8 * 1024]
   * @param {number} [max=32 * 1024]
   * @param {number} polynomial
   * @memberof Rabin
   */
  function Rabin(asModule) {
    var bits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;
    var min = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 8 * 1024;
    var max = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 32 * 1024;
    var windowSize = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 64;
    var polynomial = arguments.length > 5 ? arguments[5] : undefined;

    _classCallCheck(this, Rabin);

    this.bits = bits;
    this.min = min;
    this.max = max;
    this.asModule = asModule;
    this.rabin = new asModule.Rabin(bits, min, max, windowSize, polynomial);
    this.polynomial = polynomial;
  }
  /**
   * Fingerprints the buffer
   *
   * @param {Uint8Array} buf
   * @returns {Array<number>}
   * @memberof Rabin
   */


  _createClass(Rabin, [{
    key: "fingerprint",
    value: function fingerprint(buf) {
      var _this$asModule = this.asModule,
          __retain = _this$asModule.__retain,
          __release = _this$asModule.__release,
          __allocArray = _this$asModule.__allocArray,
          __getInt32Array = _this$asModule.__getInt32Array,
          Int32Array_ID = _this$asModule.Int32Array_ID,
          Uint8Array_ID = _this$asModule.Uint8Array_ID;
      var lengths = new Int32Array(Math.ceil(buf.length / this.min));

      var lengthsPtr = __retain(__allocArray(Int32Array_ID, lengths));

      var pointer = __retain(__allocArray(Uint8Array_ID, buf));

      var out = this.rabin.fingerprint(pointer, lengthsPtr);

      var processed = __getInt32Array(out);

      __release(pointer);

      __release(lengthsPtr);

      var cleanArr = [];

      for (var i = 0; i < processed.length; i++) {
        if (processed[i] === 0) break;
        cleanArr[i] = processed[i];
      }

      return cleanArr;
    }
  }]);

  return Rabin;
}();

module.exports = Rabin;